export var CUSTOM_LINE_ITEM_DEFAULTS = {
    title: "",
    price: "0.00",
    quantity: 1,
    taxable: true,
    isPhysicalProduct: true,
    weight: "",
    weight_unit: "kg",
};
